module.exports = {
	"id": "AS",
	"name": "American Samoa",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.029145,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.005829,
			"19": null,
			"20": 0.017487,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.023316,
			"27": 0.011658,
			"28": 0.081606,
			"29": 0.017487,
			"30": null,
			"31": 0.023316,
			"32": 0.005829,
			"33": 0.034974,
			"34": 0.005829,
			"35": 0.023316,
			"36": 0.034974,
			"37": null,
			"38": 0.011658,
			"39": 0.005829,
			"40": 0.011658,
			"41": 0.011658,
			"42": 0.279792,
			"43": 0.128238,
			"44": 0.05829,
			"45": 0.040803,
			"46": 0.05829,
			"47": 0.099093,
			"48": 0.81606,
			"49": 2.337429,
			"50": 0.099093,
			"51": 0.769428,
			"52": 0.332253,
			"53": 11.669658,
			"54": 3.374991,
			"55": 0.145725,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": 0.011658,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.011658,
			"11": null,
			"12": 0.279792,
			"13": null,
			"14": null,
			"15": 0.034974,
			"16": null,
			"17": 0.081606,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.011658,
			"23": null,
			"24": null,
			"25": 0.099093,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.029145,
			"30": 0.005829,
			"31": 0.023316,
			"32": null,
			"33": 0.005829,
			"34": 0.005829,
			"35": null,
			"36": null,
			"37": 0.023316,
			"38": 0.011658,
			"39": 0.029145,
			"40": 0.005829,
			"41": 0.011658,
			"42": 0.029145,
			"43": 0.652848,
			"44": 5.910606,
			"45": 6.70335,
			"46": 0.034974,
			"47": 0.542097,
			"48": 1.387302,
			"49": 3.03108,
			"50": 0.05829,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 3.654783
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.005829,
			"19": 0.011658,
			"20": null,
			"21": 0.017487,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.005829,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.023316,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.110751,
			"38": 0.05829,
			"39": 0.011658,
			"40": 0.064119,
			"41": 0.023316,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.011658
		},
		"safari": {
			"0": null,
			"4": 0.040803,
			"5": 0.17487,
			"6": 0.087435,
			"7": 6.044673,
			"8": 0.23316,
			"9": 0.238989,
			"10": 0.227331,
			"3.1": null,
			"3.2": null,
			"5.1": 0.361398,
			"6.1": 0.052461,
			"7.1": null,
			"9.1": 0.827718
		},
		"ios_saf": {
			"8": 0,
			"10": 2.79996000167,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0754556821399,
			"8.1-8.4": 0.139401175479,
			"9.0-9.2": 0.0665033130724,
			"9.3": 1.01460182764
		},
		"android": {
			"3": 0,
			"4": 0.0921931111111,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0115241388889,
			"4.1": 0.332553722222,
			"4.2-4.3": 0.831384305556,
			"4.4": 1.90642183333,
			"4.4.3-4.4.4": 1.92288488889
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.664890933962,
			"9": 0.0882598584906,
			"10": 0.288315537736,
			"11": 2.07704866981,
			"5.5": null
		},
		"op_mob": {
			"0": 0.928224584683,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0257840162412
		},
		"edge": {
			"12": 0.285621,
			"13": 0.577071,
			"14": 0.279792
		},
		"ie_mob": {
			"10": 0.0608613521127,
			"11": 0.247792647887
		},
		"bb": {
			"7": 0.0104275,
			"10": null
		},
		"samsung": {
			"0": 2.306563
		},
		"and_uc": {
			"0": 2.715321
		},
		"op_mini": {
			"0": 12.5058083991
		},
		"and_chr": {
			"0": 14.419863
		},
		"and_ff": {
			"0": 0.016684
		}
	},
	"total": 98.5751415
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AS.json
 ** module id = 465
 ** module chunks = 0
 **/